import React, { FunctionComponent } from 'react';

import EmailShare from './EmailShare';
import FacebookShare from './FacebookShare';
import SMSShare from './SMSShare';
import TwitterShare from './TwitterShare';
import WhatsAppShare from './WhatsAppShare';

import './SocialButtonsList.scss';
import { Experiments } from '../../constants/experiments';
import { useOptimizely } from '../../hooks';

const SocialButtonsList: FunctionComponent = () => {
  const trackingData = { sub_section: 'story' };
  const optimizely = useOptimizely();

  function onShare() {
    if (optimizely) {
      optimizely.track(Experiments.TrackingEvents.shareSocialButtonClick);
    }
  }

  return (
    <ul className="jg-pages-social-button-list">
      <li>
        <FacebookShare
          className="jg-pages-social-button-list__button"
          trackingData={trackingData}
          onClick={onShare}
        />
      </li>
      <li>
        <TwitterShare
          className="jg-pages-social-button-list__button"
          trackingData={trackingData}
          onClick={onShare}
        />
      </li>
      <li>
        <EmailShare
          className="jg-pages-social-button-list__button"
          trackingData={trackingData}
          onClick={onShare}
        />
      </li>
      <li className="jg-display-n@lg">
        <SMSShare
          className="jg-pages-social-button-list__button"
          trackingData={trackingData}
          onClick={onShare}
        />
      </li>
      <li className="jg-display-n@lg">
        <WhatsAppShare
          className="jg-pages-social-button-list__button"
          onClick={onShare}
        />
      </li>
    </ul>
  );
};

export default SocialButtonsList;
